import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '@tech-services/common.service';
import { OnboardingcoreService } from '@tech-services/onboardingcore.service';
import { SessionService } from '@tech-services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { TechModalDialogResendModel } from '../../../shared/techmodaldialogresend/techmodaldialogresend.model';

@Component({
  selector: 'tech-smsaddcode',
  templateUrl: './smsaddcode.component.html',
  styleUrls: ['./smsaddcode.component.scss'],
})
export class SmsaddcodeComponent implements OnInit {
  @ViewChild('code01') code01: ElementRef;
  @ViewChild('code02') code02: ElementRef;
  @ViewChild('code03') code03: ElementRef;
  @ViewChild('code04') code04: ElementRef;
  @ViewChild('code05') code05: ElementRef;
  @ViewChild('code06') code06: ElementRef;
  private unsubscribe$ = new Subject<void>();
  public form: UntypedFormGroup;
  public phoneNumber: string;

  constructor(
    private fb: UntypedFormBuilder,
    private onboardingCoreService: OnboardingcoreService,
    private commonService: CommonService,
    private sessionService: SessionService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.newform();
  }

  @HostListener('window:beforeunload', ['$event'])
  //Guardamos la estructura de la simulacion en unlocalstorage para no perderla al actualizar el navegador (F5)
  loadNotification($event: any) {
    localStorage.setItem(
      'OnboardingClient',
      JSON.stringify(this.onboardingCoreService.client)
    );
    localStorage.setItem(
      'SmsVerificationId',
      JSON.stringify(this.onboardingCoreService.smsVerificationId)
    );
  }

  ngOnInit() {
    //Revisamos la estructura de simulacion y si no esta la recogemos del Localstorage para no perderlo si se ha hecho F5
    if (Object.entries(this.onboardingCoreService.client).length == 0) {
      this.onboardingCoreService.client = JSON.parse(
        localStorage.getItem('OnboardingClient')
      );
      localStorage.removeItem('OnboardingClient'); //Eliminamos le local para no dejar residuos
    }
    if (this.onboardingCoreService.smsVerificationId == undefined) {
      this.onboardingCoreService.smsVerificationId = JSON.parse(
        localStorage.getItem('SmsVerificationId')
      );
      localStorage.removeItem('SmsVerificationId'); //Eliminamos le local para no dejar residuos
    }

    this.phoneNumber = this.onboardingCoreService.client.Phone;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      code01: ['', [Validators.required]],
      code02: ['', [Validators.required]],
      code03: ['', [Validators.required]],
      code04: ['', [Validators.required]],
      code05: ['', [Validators.required]],
      code06: ['', [Validators.required]],
    });
  }

  public keyupcode(event, input) {
    if (event.target.value !== '') {
      switch (input) {
        case 1:
          this.code02.nativeElement.focus();
          break;
        case 2:
          this.code03.nativeElement.focus();
          break;
        case 3:
          this.code04.nativeElement.focus();
          break;
        case 4:
          this.code05.nativeElement.focus();
          break;
        case 5:
          this.code06.nativeElement.focus();
          break;
        case 6:
          break;
        default:
          break;
      }
      if (this.form.status == 'VALID') {
        this.verificationCode();
      }
    }

    if (event.keyCode == 8) {
      switch (input) {
        case 1:
          this.code01.nativeElement.focus();
          break;
        case 2:
          this.form.get('code01').setValue('');
          this.code01.nativeElement.focus();
          break;
        case 3:
          this.form.get('code02').setValue('');
          this.code02.nativeElement.focus();
          break;
        case 4:
          this.form.get('code03').setValue('');
          this.code03.nativeElement.focus();
          break;
        case 5:
          this.form.get('code04').setValue('');
          this.code04.nativeElement.focus();
          break;
        case 6:
          this.form.get('code05').setValue('');
          this.code05.nativeElement.focus();
          break;
        default:
          break;
      }
    }
  }

  public verificationCode() {
    let code: string =
      this.code01.nativeElement.value +
      this.code02.nativeElement.value +
      this.code03.nativeElement.value +
      this.code04.nativeElement.value +
      this.code05.nativeElement.value +
      this.code06.nativeElement.value;

    this.onboardingCoreService.smsVerificationId;
    this.onboardingCoreService
      .verificationCode(this.onboardingCoreService.smsVerificationId, code)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        let text1: string;
        let text2: string;
        let dialogData = new TechModalDialogResendModel();
        let dialogRef: any;
        switch (data.Status) {
          case 'OK':
            this.sessionService.clientDataLogin = data;
            this.sessionService.sessionToken = data.Token;
            localStorage.setItem('SessionClientToken', data.Token);
            // this.sessionService.domain = data.Domain;
            localStorage.setItem('Language', this.sessionService.language);
            this.sessionService.clientCode = data.Code;
            localStorage.setItem('ClientCode', data.Code);
            this.sessionService.clientId = data.Id;
            localStorage.setItem('ClientId', data.Id);
            this.onboardingCoreService.showSmsCode = false;
            this.onboardingCoreService.accountConfirmed = true;
            this.router.navigate(['/signup/accountconfirmed']);
            break;
          case 'MaxSMSs':
            this.translate.get('k002473').subscribe((text: string) => {
              //Token: Exceeded maximum number of requests.
              text1 = text;
            });
            this.translate.get('k003026').subscribe((text: string) => {
              //Token: Por favor, contacte con el administrador del servicio para saber qué ha pasado en {1}.
              text2 = text.replace(
                '{1}',
                AppConfig.settings.ContactEmailOperations
              );
              this.dialogService.openModalDialog('', text1, text2, '');
            });
            this.router.navigate(['/login']);
            break;
          case 'InvalidSMSCode':
            this.clearInput();
            this.onboardingCoreService.smsVerificationId = data.VerificationId;
            this.translate.get('k002475').subscribe((text: string) => {
              //Token: We have sent you an SMS again.
              text1 = text;
            });
            this.translate.get('k002474').subscribe((text: string) => {
              //Token: We have sent you an SMS again with a confirmation code to your phone. Please try again.
              text2 = text;
              this.dialogService.openModalDialog('', text1, text2, '');
            });
            break;
          default:
            break;
        }
      });
  }
  public resendsms() {
    let text1: string;
    let text2: string;
    this.onboardingCoreService
      .resendSms(this.onboardingCoreService.smsVerificationId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        switch (data.Status) {
          case 'OK':
            this.onboardingCoreService.smsVerificationId = data.VerificationId;
            this.clearInput();
            this.translate.get('k002530').subscribe((text: string) => {
              //Token: We have sent you an SMS again
              text1 = text;
            });
            this.translate.get('k002531').subscribe((text: string) => {
              //Token: We have sent you an SMS again with a confirmation code to your phone. Please try again.
              text2 = text;
              this.dialogService.openModalDialog('', text1, text2, '');
            });
            break;
          case 'MaxSMSs':
            this.translate.get('k002532').subscribe((text: string) => {
              //Token: Exceeded maximum number of requests
              text1 = text;
            });
            this.translate.get('k003026').subscribe((text: string) => {
              //Token: Por favor, contacte con el administrador del servicio para saber qué ha pasado en {1}.
              text2 = text.replace(
                '{1}',
                AppConfig.settings.ContactEmailOperations
              );
              text2 = text;
              this.dialogService.openModalDialog('', text1, text2, '');
            });
            this.router.navigate(['/login']);
            break;
          default:
            break;
        }
      });
  }
  public clearInput() {
    this.code01.nativeElement.focus();
    this.form.reset();
  }
  public pastecode(event) {
    event.preventDefault();
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.form.get('code01').setValue(pastedText.substr(0, 1));
    this.form.get('code02').setValue(pastedText.substr(1, 1));
    this.form.get('code03').setValue(pastedText.substr(2, 1));
    this.form.get('code04').setValue(pastedText.substr(3, 1));
    this.form.get('code05').setValue(pastedText.substr(4, 1));
    this.form.get('code06').setValue(pastedText.substr(5, 1));
    this.code06.nativeElement.focus();
    if (this.form.status == 'VALID') {
      this.verificationCode();
    }
  }
}
